import React, {
  Fragment,
  useEffect,
  useMemo,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from 'react'
import { useForm } from 'react-hook-form'
import { useOffers } from './offersContext'

export const ucFirst = str => `${str.charAt(0).toUpperCase()}${str.slice(1)}`

const Filter = forwardRef((props, ref) => {
  const { register, watch, reset, resetField } = useForm({
    defaultValues: {
      experience_code: null,
      department: null,
      city: null,
      employment_type_code: null,
      title: null,
    },
  })

  const { offers, updateOffers } = useOffers()

  const allOffers = useMemo(() => offers, [])

  const createFilter = useCallback(name => {
    return Array.from(new Set(allOffers.map(offer => offer[name])))
  }, [])

  const cities = createFilter('city')

  const levels = createFilter('experience_code')

  const jobTypes = createFilter('employment_type_code')
  const departmentTypes = createFilter('department')
  useEffect(() => {
    const subscriber = watch(data => {
      const filters = Object.fromEntries(
        Object.entries(data).filter(([, v]) => !!v && v.length >= 1)
      )

      const handler = offer =>
        Object.entries(filters).every(([k, v]) =>
          k === 'title'
            ? offer[k].toLowerCase().includes(v.toLowerCase())
            : v.includes(offer[k])
        )

      updateOffers(allOffers.filter(handler))
    })

    return () => {
      subscriber.unsubscribe()
    }
  }, [watch])

  useImperativeHandle(ref, () => ({
    resetFilters: () => {
      updateOffers(allOffers)
      reset({
        experience_code: null,
        department: null,
        city: null,
        employment_type_code: null,
        title: null,
      })
    },
  }))
  return (
    <Fragment>
      <div
        className='title slide-up title--small title--big-lh title--letter-spacing title--beige vacancies__inner-title animate'
        data-element-animate
      >
        <h3>SEARCH</h3>
      </div>

      <div className='vacancies__search'>
        <form onSubmit={e => e.preventDefault()}>
          <div className='mb-40'>
            <input
              placeholder='TYPE AND Press ENTER...'
              type='text'
              size='30'
              maxLength='128'
              className='form-text vacancies__search-input'
              {...register('title')}
            />
          </div>

          <div className='flex-container align-justify flex-dir-column medium-flex-dir-row vacancies__container mb-40'>
            <div className='vacancies__form-item animate' data-element-animate>
              <p className='text text--xsmall text--big-lh text--no-space text--uppercase text--gold mb-16'>
                LOCATIONS
              </p>
              <ul className='vacancies__items-container vacancies__items-container--career'>
                <li className='vacancies__items mb-16'>
                  <label className='vacancies__label checkbox'>
                    <input
                      type='checkbox'
                      className='form-radio checkbox__input'
                      checked={!watch('city')}
                      value=''
                      onChange={() => {
                        resetField('city')
                      }}
                    />
                    <span className='checkbox__fake'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='10'
                        height='10'
                        viewBox='0 0 10 10'
                      >
                        <polyline points='2,5 4,7 8,3'></polyline>
                      </svg>
                    </span>
                    <span className='checkbox__label'>All types</span>
                  </label>
                </li>
                {cities.map((city, i) => (
                  <li className='vacancies__items mb-16' key={i}>
                    <label className='vacancies__label checkbox'>
                      <input
                        type='checkbox'
                        value={city}
                        className='form-radio checkbox__input'
                        {...register('city')}
                      />
                      <span className='checkbox__fake'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='10'
                          height='10'
                          viewBox='0 0 10 10'
                        >
                          <polyline points='2,5 4,7 8,3'></polyline>
                        </svg>
                      </span>
                      <span className='checkbox__label'>{city}</span>
                    </label>
                  </li>
                ))}
              </ul>
            </div>
            <div className='vacancies__form-item animate' data-element-animate>
              <p className='text text--xsmall text--big-lh text--no-space text--uppercase text--gold mb-16'>
                Department
              </p>
              <ul className='vacancies__items-container vacancies__items-container--career'>
                <li className='vacancies__items mb-16'>
                  <label className='vacancies__label checkbox'>
                    <input
                      className='form-radio checkbox__input'
                      type='checkbox'
                      checked={!watch('department')}
                      value=''
                      onChange={() => {
                        resetField('department')
                      }}
                    />
                    <span className='checkbox__fake'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='10'
                        height='10'
                        viewBox='0 0 10 10'
                      >
                        <polyline points='2,5 4,7 8,3'></polyline>
                      </svg>
                    </span>
                    <span className='checkbox__label'>All types</span>
                  </label>
                </li>
                {departmentTypes.map((type, i) => (
                  <li className='vacancies__items mb-16' key={i}>
                    <label className='vacancies__label checkbox'>
                      <input
                        type='checkbox'
                        className='form-radio checkbox__input'
                        value={type}
                        {...register('department')}
                      />
                      <span className='checkbox__fake'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='10'
                          height='10'
                          viewBox='0 0 10 10'
                        >
                          <polyline points='2,5 4,7 8,3'></polyline>
                        </svg>
                      </span>
                      <span className='checkbox__label'>{ucFirst(type)}</span>
                    </label>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className='flex-container align-justify flex-dir-column medium-flex-dir-row vacancies__container mb-40'>
            <div className='vacancies__form-item animate' data-element-animate>
              <p className='text text--xsmall text--big-lh text--no-space text--uppercase text--gold mb-16'>
                JOB TYPE
              </p>
              <ul className='vacancies__items-container vacancies__items-container--career'>
                <li className='vacancies__items mb-16'>
                  <label className='vacancies__label checkbox'>
                    <input
                      type='checkbox'
                      checked={!watch('employment_type_code')}
                      value=''
                      onChange={() => {
                        resetField('employment_type_code')
                      }}
                      className='form-radio checkbox__input'
                    />
                    <span className='checkbox__fake'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='10'
                        height='10'
                        viewBox='0 0 10 10'
                      >
                        <polyline points='2,5 4,7 8,3'></polyline>
                      </svg>
                    </span>
                    <span className='checkbox__label'>All types</span>
                  </label>
                </li>
                {jobTypes.map((type, i) => (
                  <li className='vacancies__items mb-16' key={i}>
                    <label className='vacancies__label checkbox'>
                      <input
                        type='checkbox'
                        className='form-radio checkbox__input'
                        value={type}
                        {...register('employment_type_code')}
                      />
                      <span className='checkbox__fake'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='10'
                          height='10'
                          viewBox='0 0 10 10'
                        >
                          <polyline points='2,5 4,7 8,3'></polyline>
                        </svg>
                      </span>
                      <span className='checkbox__label'>{ucFirst(type)}</span>
                    </label>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className='text text--xsmall text--big-lh text--no-space text--uppercase text--gold mb-16'>
                career level
              </p>

              <div
                className='vacancies__form-item animate'
                data-element-animate
              >
                <ul className='vacancies__items-container vacancies__items-container--career'>
                  <li className='vacancies__items mb-16'>
                    <label className='vacancies__label checkbox'>
                      <input
                        type='checkbox'
                        checked={!watch('experience_code')}
                        value=''
                        onChange={() => {
                          resetField('experience_code')
                        }}
                        className='form-radio checkbox__input'
                      />
                      <span className='checkbox__fake'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='10'
                          height='10'
                          viewBox='0 0 10 10'
                        >
                          <polyline points='2,5 4,7 8,3'></polyline>
                        </svg>
                      </span>
                      <span className='checkbox__label'>All types</span>
                    </label>
                  </li>

                  {levels.map((v, i) => (
                    <li className='vacancies__items mb-16' key={i}>
                      <label className='vacancies__label checkbox'>
                        <input
                          type='checkbox'
                          value={v}
                          className='form-radio checkbox__input'
                          {...register('experience_code')}
                        />
                        <span className='checkbox__fake'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='10'
                            height='10'
                            viewBox='0 0 10 10'
                          >
                            <polyline points='2,5 4,7 8,3'></polyline>
                          </svg>
                        </span>
                        <span className='checkbox__label'>
                          {ucFirst(v.replace('_', ''))}
                        </span>
                      </label>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Fragment>
  )
})

Filter.displayName = 'Filter'

export default Filter
